import React from "react";
import { Modal } from "semantic-ui-react";
import ReactPlayer from "react-player";
import { styles } from "./styles";
const ModalMultimediaVideo = props => {
  return (
    <Modal
      trigger={
        <button className="btn p-0" type="button" style={styles.textDecoration}>
          {props.render}
        </button>
      }
      basic
      closeIcon
      size="large"
      style={styles.modalView}
    >
      <Modal.Content style={styles.modalContent}>
        <ReactPlayer
          url={props.video.video.data.url}
          playing
          width="100%"
          height={window.screen.height < window.screen.width ? "80vh" : "40vh"}
          controls
        />
      </Modal.Content>
    </Modal>
  );
};

export default ModalMultimediaVideo;
